/**
 * 封装请求
 */

import axios, {
  AxiosRequestConfig, 
  AxiosResponse, 
  AxiosError
} from 'axios';

import * as Sentry from '@sentry/nextjs'

import queryString from 'querystring'

import {showToast} from '@turingshequ/react-toast/src'
import redirectLogin from './redirectLogin'
import API from './api';
import * as ApiType from './interface';


const service = axios.create({
  baseURL: getBaseUrl(),
  withCredentials: true,
  headers: {
    'content-type': 'application/json',
  }
})

service.interceptors.request.use(handleRequest, handleError)

service.interceptors.response.use(handleResponse, handleResponseError)

export default service;

export {
  API,
  ApiType,
  uploadImg,
  uploadImgBase64
}


function handleRequest(config: AxiosRequestConfig) {
  if(config?.params?.useMock) {
    config.baseURL = 'http://live.yapi.inner.youdao.com/mock/66/'
  }
  return config
}

function handleResponse(response: AxiosResponse) {
  const {status, data} = response;

  if(status !== 200) {
    showToast({
      type: 'error',
      message: data?.msg || data?.description || '网络出现问题请稍后重试~'
    })
    return Promise.reject();
  }

  if(data.code == 0) {
    return response.data;
  }

  if(data.code == 1) {
    redirectLogin();
    const err = new Error('need login');
    (err as any).sign = 'NEEDLOGIN';
    (err as any).ret = data
    throw err
  }

  if(data.code === 2) {
    showToast({
      type: 'error',
      message: data?.msg || data?.description || '网络出现问题请稍后重试~'
    })
    return Promise.reject()
  }

  if(data.code == -1) {
    if (data.description === '正在处理中') {
      data.description = '操作过于频繁，请稍后再试试～'
    }
  }

  return response.data;
}

function handleError(error: AxiosError) {
  console.log('handleError  error ->', error)
  return Promise.reject(error)
}

function handleResponseError(error: AxiosError) {
  console.log('handleResponseError  error ->', error)

  const {
    config: { url, params, headers, data },
    response
  } = error;

  const err = new Error(`接口错误：${url}`);
  err.name = '接口请求错误';
  // 手动捕获异常
  Sentry.captureException(err, scope => {
    scope.setExtra('request headers', headers);
    scope.setExtra('request data', data);
    scope.setExtra('request params', params);

    // 设置响应信息
    if (response) {
      scope.setExtra('response status', response.status);
      scope.setExtra('response headers', response.headers);
      scope.setExtra('response data', response.data);
    }
    return scope;
  });

  return Promise.reject(error)
}

function getBaseUrl() {
  if(process.env.NEXT_PUBLIC_MOCK === 'MOCK') {
    return process.env.NEXT_PUBLIC_MOCK_HOST
  }
  let host = process.env.NEXT_PUBLIC_API_HOST as string
  if (typeof location !== 'undefined') {
    host = host.replace(/^https?:/, location.protocol)
  }
  return host
}

function uploadImg(formData: FormData) {
  return service.post(API.common.upload, formData, {
    headers: {
      'content-type': 'multipart/form-data',
    }
  })
}


function file2Base64(file: any) {
  return new Promise<string>((resolve, reject) => {
    if(!file) {
      reject('need file data');
    }
      // 创建流对象
    const reader = new FileReader();
    reader.readAsDataURL(file);
    // 转换完毕
    reader.onload = (e: any) => {
      resolve(e.target.result)
    }
    reader.onerror = e => {
      reject(e)
    }
  })
}

function base64ToBlob({ b64data = '', contentType = '', sliceSize = 512 } = {}) {
  return new Promise(resolve => {
    // 使用 atob() 方法将数据解码
    const byteCharacters = atob(b64data)
    const byteArrays = []
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize)
      const byteNumbers = []
      for (let i = 0; i < slice.length; i++) {
        byteNumbers.push(slice.charCodeAt(i))
      }
      // 8 位无符号整数值的类型化数组。内容将初始化为 0。
      // 如果无法分配请求数目的字节，则将引发异常。
      byteArrays.push(new Uint8Array(byteNumbers))
    }
    let result = new Blob(byteArrays, {
      type: contentType
    })
    result = Object.assign(result, {
      // 这里一定要处理一下 URL.createObjectURL
      preview: URL.createObjectURL(result),
      name: 'save.png'
    })
    resolve(result)
  })
}

async function uploadImgBase64(file: any) {
  try {
    const base64 = await file2Base64(file);
    const b64data = base64.split(',')[1]

    // 这里从文件转为base64又转为blob是历史原因，老的上传接口支持base64，现有接口需要blob，为了不影响老逻辑，暂时在这里二次转化一下
    const blobData = await base64ToBlob({ b64data, contentType: 'image/png' })

    const formData = new FormData()
    formData.append('file', blobData as Blob, 'save.png');

    const result = await fetch('https://adaplearn-gateway.youdao.com/common/nos', {
      method: 'POST',
      body: formData,
      credentials: 'include'
    })

    const data = await result.json()

    if (data.err === 0 && data.data.startsWith('http')) {
      return data.data
    }

    throw new Error('上传失败')
  } catch (err) {
    console.error('uploadImg:', err)
  }
}
